import { ENV } from "../path";
import { EventTypes, trackEvent } from "./Analytics";
import { getPlaystoreLinks } from "./attribution";

export function formatDate(inputDate) {
  const date = new Date(inputDate);

  const options = {
    day: "2-digit",
    month: "short",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };

  return new Intl.DateTimeFormat("en-US", options).format(date);
}

export const redirectToStore = (redirectLocation) => {
  const userAgent = navigator.userAgent || window.opera || navigator.vendor;
  const isIOS = /iPad|iPhone|iPod/.test(userAgent);
  const isAndroid = userAgent.includes("Android");
  const { intentUrl, playStoreLink } = getPlaystoreLinks();

  if (ENV === "prod") {
    trackEvent(EventTypes.DOWNLOAD_CLICK, { location: redirectLocation });
  }
  if (isIOS) {
    window.location.href =
      "https://apps.apple.com/in/app/feedants/id6477408585";
  } else if(isAndroid) {
    window.location.href = intentUrl;
  } else {
    window.location.href = playStoreLink;
  }
};
